import { render, staticRenderFns } from "./BuySectionDeliveryModal.vue?vue&type=template&id=ee7ae7ea&scoped=true&"
import script from "./BuySectionDeliveryModal.vue?vue&type=script&lang=ts&"
export * from "./BuySectionDeliveryModal.vue?vue&type=script&lang=ts&"
import style0 from "./BuySectionDeliveryModal.vue?vue&type=style&index=0&id=ee7ae7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7ae7ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsSpinner: require('/var/www/packages/theme/components/icons/spinner/Spinner.vue').default,AtomsAddToCartButton: require('/var/www/packages/theme/components/atoms/AddToCartButton.vue').default,WrappersProductAddToCartText: require('/var/www/packages/theme/components/wrappers/ProductAddToCartText.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,AtomsKELabel: require('/var/www/packages/theme/components/atoms/KELabel.vue').default,AtomsRadioButton: require('/var/www/packages/theme/components/atoms/RadioComponent/RadioButton.vue').default,IconsSocialStoresIcon24px: require('/var/www/packages/theme/components/icons/social/StoresIcon24px.vue').default,AtomsModal: require('/var/www/packages/theme/components/atoms/Modal.vue').default})
